import axios from "axios";

export const saveRedirection = (data, setErrorMessage) => {
    axios.post(process.env.REACT_APP_BASE_URL + '/api/redirections/save?code=' + process.env.REACT_APP_API_KEY, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        console.log(res);
        console.log(res.data);
        window.location = "/redirections";
    }).catch((error) => {
        if (error.response.status === 400 && error.response.data === "Serial number already exists!") {
            setErrorMessage("Hiba történt! Ez a gyáriszám már létezik!  ");
        }
        if (error.response.data === "PublicUrl already exists!") {
            setErrorMessage("Hiba történt! A publikus url már létezik! ");
        }
        if (error.response.data === "The maximum size of Comment is 100 characters!") {
            setErrorMessage("Hiba történt! A megjegyzés maximum 100 karakter lehet! ");
        }

        if (error.response.data === "Access denied!") {
            sessionStorage.clear();
            window.location = "/";
        }
        console.log(error);
    });
}

export const deleteRedirection = (token, action) => {
    axios.post(process.env.REACT_APP_BASE_URL + '/api/redirections/delete/' + token + '?code=' + process.env.REACT_APP_API_KEY, {
        "sessionToken": sessionStorage.getItem("sessionToken")
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        console.log(res);
        console.log(res.data);
        if (action === "reload") {
            window.location.reload(true);
        } else if (action === "redirect") {
            window.location = "/redirections";
        }
    }).catch((error) => {
        if (error.response.data === "Access denied!") {
            sessionStorage.clear();
            window.location = "/";
        }
    });
}

export const archiveRedirection = (token) => {
    axios.post(process.env.REACT_APP_BASE_URL + '/api/redirections/archive/' + token + '?code=' + process.env.REACT_APP_API_KEY, {
        "sessionToken": sessionStorage.getItem("sessionToken")
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        console.log(res);
        console.log(res.data);
        window.location.reload(true);
    }).catch((error) => {
        if (error.response.data === "Access denied!") {
            sessionStorage.clear();
            window.location = "/";
        }
    });
}

export const saveUser = (data, setErrorMessage) => {
    axios.post(process.env.REACT_APP_BASE_URL + '/api/users/save?code=' + process.env.REACT_APP_API_KEY, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        console.log(res);
        console.log(res.data);
        window.location = "/users";
    }).catch((error) => {
        console.log(error)

        if (error.response.data === "Username already exists!") {
            setErrorMessage("Hiba történt! Ez a felhasználónév már létezik! ");
        }

        if (error.response.data === "Full name can not be modified on protected admin!") {
            setErrorMessage("Hiba történt! A védett adminnál nem módosítható a név! ")
        }

        if (error.response.data === "Role can not be modified on protected admin!") {
            setErrorMessage("Hiba történt! A védett adminnál nem módosítható a szerepkör.");
        }

        if (error.response.data === "Status can not be modified on protected admin!") {
            setErrorMessage("Hiba történt! A védett adminnál nem módosítható a státusz.");
        }

        if (error.response.data === "Password can not be modified on protected admin!") {
            setErrorMessage("Hiba történt! A védett adminnál nem módosítható a jelszó.");
        }

        if (error.response.data === "Username can not be modified on protected admin!") {
            setErrorMessage("Hiba történt! A védett adminnál nem módosítható a felhasználónév.");
        }

    });
}

export const deleteUser = (token, setErrorMessage, action) => {
    axios.post(process.env.REACT_APP_BASE_URL + '/api/users/delete/' + token + '?code=' + process.env.REACT_APP_API_KEY, {
        "sessionToken": sessionStorage.getItem("sessionToken")
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        console.log(res);
        console.log(res.data);
        if (action === "reload") {
            window.location.reload(true);
        } else if (action === "redirect") {
            window.location = "/redirections";
        }
    }).catch((error) => {
        if (error.response.data === "Access denied!") {
            sessionStorage.clear();
            window.location = "/";
        }

        if (error.response.data === "Admin cannot be deleted!") {
            setErrorMessage("Hiba történt! A védett admin nem törölhető! ");
        }
        if (error.response.data === "Cannot delete yourself!") {
            setErrorMessage("Hiba történt! Magadat nem tudod törölni. ");
        }

    });
}

export const sendChangePassword = (data, setErrorMessage) => {
    axios.post(process.env.REACT_APP_BASE_URL + '/api/users/changepassword?code=' + process.env.REACT_APP_API_KEY, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        console.log(res);
        console.log(res.data);
        if (sessionStorage.getItem("role") === "admin") {
            window.location = "/users";
        } else {
            window.location = "/redirections";
        }
    }).catch((error) => {
        if (error.response.data === "Password is not strong enough!") {
            setErrorMessage("Hiba történt! A jelszó nem elég erős! ");
        }

        if (error.response.data === "Access denied!") {
            sessionStorage.clear();
            window.location = "/";
        }
    });
}

export const logout = () => {
    axios.post(process.env.REACT_APP_BASE_URL + '/api/logout?code=' + process.env.REACT_APP_API_KEY, {
        "sessionToken": sessionStorage.getItem("sessionToken")
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        console.log(res);
        console.log(res.data);
        sessionStorage.clear();
        window.location = "/";
    }).catch((error) => {
        console.log(error)
    });
}

export const isValidPublicUrl = (url) => {
    if (url.startsWith(process.env.REACT_APP_BASE_URL + "/api/redirect/") && ((process.env.REACT_APP_BASE_URL + "/api/redirect/").length < url.length)) {
        return true;
    } else {
        return false;
    }
};

export const handleChange = (event, setFormData) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
};

export const handleSubmit = (event, setValidated) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
    }
    setValidated(true);
};

export const getModalData = (actionName, urlLink, modalShow, setActionName, setUrlLink, setModalShow) => {
    setActionName({
        'name': actionName.name,
        'action': actionName.action,
        'values': actionName.values,
    });
    setUrlLink(urlLink);
    return setModalShow(true);
}